import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { QuoteProvider } from "./lib/quoteContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import BeforeAfter from "./components/BeforeAfter";
import Testimonials from "./components/Testimonials";
import Gallery from "./components/Gallery";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import QuoteModal from "./components/QuoteModal";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";

const Home = () => {
  const location = useLocation();
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      // Small delay so the section is mounted before we scroll
      setTimeout(() => {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  }, [location]);
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <BeforeAfter />
        <Testimonials />
        <Gallery />
        <CTASection />
      </main>
      <Footer />
    </>
  );
};

// Scroll to top on route change (for legal pages)
function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    if (!location.state?.scrollTo) {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [location.pathname, location.state]);
  return null;
}

function App() {
  return (
    <div className="App">
      <QuoteProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
          <QuoteModal />
        </BrowserRouter>
      </QuoteProvider>
    </div>
  );
}

export default App;
